import { SENVIA_MARK, SENVIA_TEAL, SENVIA_WORDMARK } from "../brand/senvia";

/** Senvia POS (the store app's brand): rounded teal icon with the white S, optionally with the wordmark. */
export function SenviaIcon({ size = 30, className }: { size?: number; className?: string }) {
  const [x, y, w, h] = SENVIA_MARK.viewBox.split(" ").map(Number) as [number, number, number, number];
  const side = Math.max(w, h) / 0.6;
  const ox = x - (side - w) / 2, oy = y - (side - h) / 2;
  return (
    <svg className={className} width={size} height={size} viewBox={[ox, oy, side, side].join(" ")} role="img" aria-label="Senvia POS">
      <rect x={ox} y={oy} width={side} height={side} rx={side * 0.225} fill={SENVIA_TEAL} />
      <path fill="#FFFFFF" fillRule="evenodd" d={SENVIA_MARK.d} />
    </svg>
  );
}
export function SenviaWordmark({ height = 28, className }: { height?: number; className?: string }) {
  const [, , w, h] = SENVIA_WORDMARK.viewBox.split(" ").map(Number) as [number, number, number, number];
  return (
    <svg className={className} height={height} width={(height * w) / h} viewBox={SENVIA_WORDMARK.viewBox} role="img" aria-label="Senvia POS">
      <path fill={SENVIA_TEAL} fillRule="evenodd" d={SENVIA_WORDMARK.d} />
    </svg>
  );
}
/** Icon above the wordmark, as on the splash screen. */
export function SenviaLockup({ size = 72 }: { size?: number }) {
  return (
    <div className="senvia-lockup" data-testid="senvia-logo">
      <SenviaIcon size={size} />
      <SenviaWordmark height={Math.round(size * 0.5)} />
    </div>
  );
}
